/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import classes from './terms-of-services.module.scss';
import { useTranslation } from 'react-i18next';

const TermsOfServicesModal = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button className={classes.text} type='link' onClick={showModal}>{t('common.terms-of-services')}</Button>
      <Modal
        cancelButtonProps={{
          style: {
            display: 'none',
          },
        }}
        okText={t('common.close')}
        title={t('terms.title')}
        open={isModalOpen}
        onOk={handleClose}
        onCancel={handleClose}
        closable
        className={classes.modal}
        width="1000px"
        centered
      >
        <ol className={classes.list}>
          <li className={classes.listItemTitle}>
            <h3>{t('terms.registration-title')}</h3>
            <p className={classes.listItemText}>{t('terms.registration-text')}</p>
          </li>
          <li className={classes.listItemTitle}>
            <h3>{t('terms.conduct-title')}</h3>
            <p className={classes.listItemText}>{t('terms.conduct-text')}</p>
          </li>
          <li className={classes.listItemTitle}>
            <h3>{t('terms.property-title')}</h3>
            <p className={classes.listItemText}>{t('terms.property-text')}</p>
          </li>
          <li className={classes.listItemTitle}>
            <h3>{t('terms.liability-title')}</h3>
            <p className={classes.listItemText}>{t('terms.liability-text')}</p>
          </li>
          <li className={classes.listItemTitle}>
            <h3>{t('terms.termination-title')}</h3>
            <p className={classes.listItemText}>{t('terms.termination-text')}</p>
          </li>
          <li className={classes.listItemTitle}>
            <h3>{t('terms.changes-title')}</h3>
            <p className={classes.listItemText}>{t('terms.changes-text')}</p>
          </li>
        </ol>
      </Modal>
    </>
  );
};

export default TermsOfServicesModal;
